module.exports = __webpack_public_path__ + "img/fayi_logo.407e9e11.jpg";